import { HealthTable } from '@/components/table/HealthTable/HealthTable';

export default function Health() {
  return <HealthTable />;
}
